import { render, staticRenderFns } from "./CompanyBgczListBlock.vue?vue&type=template&id=48480a70&scoped=true"
import script from "./CompanyBgczListBlock.vue?vue&type=script&lang=js"
export * from "./CompanyBgczListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48480a70",
  null
  
)

export default component.exports